export const dataHooks = {
  composerSidebarContainer: 'composer-sidebar-container',
};
